'use strict';

import $ from 'jquery';

import { observe } from "mobx";
import fixElementTop from './element-top';
import notification from './notification';

const ajaxInjection = require('./../modules/ajaxInjector.js');
//const Notify = require('./../modules/notify.js');
const body = $('#body');
let counter = 0;
let data = {};
const compareToggle = $('.compare-toggle');
const compareToggleMobile = $('#compare-toggle-mobile');


const showProduct = new Event('showProduct');


function formatPrice(price) {
    return parseFloat(price.replace(',', '')).toLocaleString('nl-NL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

function puntComma(data) {
    $.each(data.products, function (index, element) {
        data.products[index].groepen.primary.prijs = formatPrice(element.groepen.primary.price);
    });
    return data;
}

function countCompared(data = false, force = false) {
    if (data) {
        if ( data.products && data.products.length > 0 ) {
            window.compareIds = data.products.map(product => product.id);
        }

        if (Object.values(data)[0]) {
            counter = Object.values(data)[0].length;
        } else {
            counter = 0;
        }

        if (!body.hasClass('compare')) {
            compareToggle.attr('data-count', counter);
        }
    }

    if (force) compareToggle.attr('data-count', counter);
}


function compareToggler() {
    if (body.hasClass('compare')) {
        body.removeClass('compare');
        countCompared(false, true);
    } else {
        $('.compare-holder').css('display', 'block');
        body.addClass('compare');
        //compareToggle.html(g.lang.close);
        countCompared();
    }

    window.dispatchEvent(showProduct);
    body.toggleClass('overlay');
}

compareToggle.on('click', function (e) {
    e.preventDefault();
    compareToggler();
});
compareToggleMobile.on('click', function (e) {
    e.preventDefault();
    compareToggler();
});


$('body').on('click', function (e) {
    if ( $(this).hasClass('compare') ) {
        if ( $(e.target).is('#overlay') ) {
            compareToggler();
        }
    }
});

$('.compare-holder').on('click', '.add-to-cart-submit', () => {
    compareToggler();
});

body.on('click', '.deletecompare', function () {
    let data = {'id': $(this).data('id')};

    window.store.product.removeCompare($(this).data('id'));
});

body.on('click', '.compare', function () {
    const data = {'id': $(this).data('id')};
    let element = $(this);
    let url = '';

    if ($(this).is($('input:checked')) === true) {
        $('.compare-link').show();
        url = '/ajax/products/addCompare';
    } else {
        $('.compare-link').hide();
        url = '/ajax/products/deleteCompare';
    }

    ajaxInjection.request(url, 'POST', data, '.compare-slider', require('./../template/product/compare.hbs'))
        .then(function (response) {
            if (response.succes === 0) {
                element.prop('checked', false);
                //new Notify(g.lang.max_compared_limit_reached, 'warning');
                notification(g.lang.max_compared_limit_reached, 'warning');
            }

            return ajaxInjection.request('/ajax/products/compare', 'POST');
        })
        .then(insertCompareData);
});

function insertCompareData (compareData) {
    const data = puntComma(compareData);
    ajaxInjection.insert(data, '.compare-slider', require('./../template/product/compare.hbs'));
    countCompared(data);
}




// Hide compare
document.addEventListener('animationend', function (e) {
    if ( e.animationName === 'close-compare' ) {
        e.target.style.display = 'none';
    }
});





observe(window.store.product, 'compareProducts', () => {
    insertCompareData({
        products: window.store.product.compareProducts
    });
});

window.store.product.fetchCompare();
